exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messages[data-v-805a6fc0] {\n  border: thin solid #bbb;\n}", ""]);

// exports
